import { get } from './_httpClient';

export async function getAdminDashboard() {
  const { status, message, data } = await get('/clp/admin/dashboard');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getHasUpdatedStudent({ batchId }) {
  const { status, message, data } = await get(`/clp/metrics/users-update-status?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

// Per-student breakdown (nama + status) di balik metrik "Status Update Data Mahasiswa" —
// dipakai halaman drill-down, bukan tabel penuh di dashboard.
export async function getHasUpdatedStudentList({ batchId }) {
  const { status, message, data } = await get(`/clp/metrics/users-update-status/list?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getNewUsersRegistrations({ batchId }) {
  const { status, message, data } = await get(`/clp/metrics/daily-registrations?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getCountUsersRegistrationsByUniversities({ batchId }) {
  const { status, message, data } = await get(`/clp/metrics/university-distributions?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getCountActiveUsersGroupByInstitution({ batchId }) {
  const { status, message, data } = await get(`/clp/metrics/institution-distributions?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getTimelineByBatchId({ batchId }) {
  const { status, message, data } = await get(`/clp/dashboard/timeline?batchId=${batchId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
